import React, { forwardRef } from 'react'
import ReactSelect, { OptionProps, Props, SelectInstance, SingleValueProps } from 'react-select'

import { CustomOption } from '../customOptions/CustomOption'
import { CustomSingleValue } from '../customOptions/CustomSingleValue'

export const CountrySelectWithFlags = forwardRef<SelectInstance<any, boolean>, Props<any, boolean>>((props, ref) => {
  return (
    <ReactSelect
      {...props}
      ref={ref}
      components={{
        SingleValue: CustomSingleValue as React.ComponentType<SingleValueProps<any>>,
        Option: CustomOption as React.ComponentType<OptionProps<any>>,
        IndicatorSeparator: () => null,
        DropdownIndicator: () => null,
      }}
    />
  )
})

CountrySelectWithFlags.displayName = 'CountrySelectWithFlags'
